import React from "react";
import chartImg from "../../assets/img/images/ebtc-liquidity.png";
import SalesTabButton from "./SalesTabButton";
import SalesTabContent2 from "./SalesTabContent2";
import SalesTabContent1 from "./SalesTabContent1";

const Liquidity = () => {
  const chart_info_list = [
    "USDC: 35%",
    "yBTC: 15%",
    "XLM: 15%",
    "Gold (Mintx): 15%",
    "Silver (Mintx): 15%",
    "Claimable balance pool: 5%",
  ];

  return (
    <section id="liquidity" className="chart-area chart-bg ">
      <div className="container">
        <div className="chart-inner">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-6 col-md-10 order-0 order-lg-2">
              <div className="chart-wrap wow fadeInRight" data-wow-delay=".2s">
                <img src={chartImg} alt="" />
                <ul>
                  {chart_info_list.map((x, index) => (
                    <li key={index}>{x}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-lg-6 col-md-10">
              <div
                className="chart-content wow fadeInLeft"
                data-wow-delay=".2s"
              >
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <SalesTabButton
                    title="Liquidity Allocation"
                    className="active"
                    id="funding-tab"
                    target="#funding"
                    ariaControls="funding"
                    ariaSelected={true}
                  />

                  <SalesTabButton
                    title="eBTC Stats"
                    className=""
                    id="token-tab"
                    target="#token"
                    ariaControls="token"
                    ariaSelected={false}
                  />
                </ul>

                <div className="tab-content" id="myTabContent">
                  <SalesTabContent2
                    className={"show active"}
                    id="funding"
                    ariaLabel="funding-tab"
                    title=""
                    description=" Funds from Virtual Miner sales are placed into liquidity pools for the lifetime of the project"
                    link="/"
                  />

                  <SalesTabContent1
                    className={""}
                    id="token"
                    ariaLabel="token-tab"
                    title=""
                    description="Similar to BTC, eBTC has a maximum supply of 21M and has a quartering each year, reducing the available eBTC to be virtually mined each year"
                    link=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Liquidity;
